var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb10 feet-r" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.AddARow")))]
          ),
          _c("importAndDowloadCmp", {
            staticClass: "feet-btn",
            attrs: {
              "partition-id": _vm.partitionId,
              "subregion-list": _vm.subregionList,
              "get-data-func": _vm.onDownloadOffer,
            },
            on: { importList: _vm.onImportList },
          }),
          _c(
            "el-popover",
            { attrs: { placement: "bottom-start", trigger: "hover" } },
            [
              _c(
                "div",
                { staticClass: "feet" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onClear },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyCurrentPartition")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "feet-btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onAllClear },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyAllPartitions")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "feet-btn",
                  attrs: { slot: "reference", size: "small" },
                  slot: "reference",
                },
                [_vm._v(_vm._s(_vm.$t("basicData.ClearTheOffer")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.partitionId
        ? _c("TableCmp", {
            ref: "defaultTableRef",
            attrs: { "table-data": _vm.defaultPartitionObj.default.arr },
            on: {
              change: function (arr) {
                return (_vm.defaultPartitionObj.default.arr = arr)
              },
            },
          })
        : _vm._e(),
      _vm.partitionId && _vm.subregionList.length > 0
        ? _c("TableCmp", {
            ref: "tableRef",
            attrs: { "table-data": _vm.getPartitionArr },
            on: { change: _vm.changePartition },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }